import { createPortal } from "react-dom";

import { SelectionBar } from "@/v2/components/SelectionBar";

export interface EntriesSelectionOverlayProps {
	selectionMode: boolean;
	shellContainer: HTMLElement | null;
	selectedCount: number;
	allCurrentPageSelected: boolean;
	someCurrentPageSelected: boolean;
	onSelectAll: () => void;
	onClose: () => void;
}

export function EntriesSelectionOverlay({
	selectionMode,
	shellContainer,
	selectedCount,
	allCurrentPageSelected,
	someCurrentPageSelected,
	onSelectAll,
	onClose,
}: EntriesSelectionOverlayProps) {
	if (!selectionMode || !shellContainer) return null;

	return createPortal(
		<div className="absolute inset-x-0 top-0 z-50 flex h-14 items-center border-b border-border bg-background">
			<SelectionBar
				selectedCount={selectedCount}
				allCurrentPageSelected={allCurrentPageSelected}
				someCurrentPageSelected={someCurrentPageSelected}
				onSelectAll={onSelectAll}
				onClose={onClose}
			/>
		</div>,
		shellContainer,
	);
}
